import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthGate, ProtectedRoute } from "@/lib/auth";
import LoginPage from "@/admin/LoginPage";
import AdminLayout from "@/admin/AdminLayout";
import ProjectsPage from "@/admin/ProjectsPage";
import ProjectPage from "@/admin/ProjectPage";
import DatasetPage from "@/admin/DatasetPage";
import AssistantPage from "@/admin/AssistantPage";
import HostedChat from "@/public/HostedChat";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public: paylaşılan asistan linki / widget — giriş gerektirmez */}
          <Route path="/a/:slug" element={<HostedChat />} />

          {/* Admin: oturum gerekir */}
          <Route element={<AuthGate />}>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<AdminLayout />}>
                <Route path="/" element={<ProjectsPage />} />
                <Route path="/projects/:pid" element={<ProjectPage />} />
                <Route path="/datasets/:did" element={<DatasetPage />} />
                <Route path="/assistants/:aid" element={<AssistantPage />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
